import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    vehicleCount: '',
    message: ''
  });

  const [formErrors, setFormErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    
    // Clear error when user types
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: ''
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) {
      errors.name = 'El nombre es requerido';
    }
    
    if (!formData.email.trim()) {
      errors.email = 'El email es requerido';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email inválido';
    }
    
    if (!formData.phone.trim()) {
      errors.phone = 'El teléfono es requerido';
    }
    
    if (!formData.message.trim()) {
      errors.message = 'El mensaje es requerido';
    }
    
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const errors = validateForm();
    
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    // Simulate form submission
    setTimeout(() => {
      setFormSubmitted(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        vehicleCount: '',
        message: ''
      });
      
      // Reset form submission status after 5 seconds
      setTimeout(() => {
        setFormSubmitted(false);
      }, 5000);
    }, 1000);
  };

  return (
    <section id="contact" className="section section-alt">
      <div className="container">
        <h2 className="section-title">Contáctanos</h2>
        <p className="section-subtitle">
          ¿Listo para optimizar la gestión de tu flota? Completa el formulario y un especialista 
          se pondrá en contacto contigo para brindarte toda la información que necesitas.
        </p>

        <div className="contact-container">
          <div className="contact-info">
            <h3>Información de Contacto</h3>
            <p>Estamos aquí para ayudarte. Contáctanos por cualquiera de estos medios o completa el formulario.</p>
            
            <div className="contact-details">
              <div className="contact-detail">
                <div className="contact-icon">
                  <MapPin size={20} />
                </div>
                <div className="contact-text">
                  <h4>Dirección</h4>
                  <p>Los Laureles, Cabimas 4013, Estado Zulia, Venezuela</p>
                </div>
              </div>
              
              <div className="contact-detail">
                <div className="contact-icon">
                  <Phone size={20} />
                </div>
                <div className="contact-text">
                  <h4>Teléfono</h4>
                  <p>+58 412 6594257</p>
                </div>
              </div>
              
              <div className="contact-detail">
                <div className="contact-icon">
                  <Mail size={20} />
                </div>
                <div className="contact-text">
                  <h4>Email</h4>
                  <p>soporte@villatracking.com</p>
                </div>
              </div>
              
              <div className="contact-detail">
                <div className="contact-icon">
                  <Clock size={20} />
                </div>
                <div className="contact-text">
                  <h4>Horario de Atención</h4>
                  <p>Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>
            
            <div className="contact-map">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31376.63444693388!2d-71.46499185!3d10.412629199999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e89c5f7196d8f93%3A0x7f3d7a5850ad8d0c!2sLos%20Laureles%2C%20Cabimas%204013%2C%20Zulia%2C%20Venezuela!5e0!3m2!1sen!2sus!4v1687890234567!5m2!1sen!2sus" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación de VillaTracking"
              ></iframe>
            </div>
          </div>
          
          <div className="contact-form-container">
            <h3>Envíanos un Mensaje</h3>
            
            {formSubmitted ? (
              <div className="form-success">
                <div className="success-icon">
                  <Send size={32} />
                </div>
                <h4>¡Mensaje Enviado!</h4>
                <p>Gracias por contactarnos. Un especialista se pondrá en contacto contigo muy pronto.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Nombre Completo *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className={formErrors.name ? 'error' : ''}
                  />
                  {formErrors.name && <span className="error-message">{formErrors.name}</span>}
                  
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={formErrors.email ? 'error' : ''}
                    />
                    {formErrors.email && <span className="error-message">{formErrors.email}</span>}
                    
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="phone">Teléfono *</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className={formErrors.phone ? 'error' : ''}
                    />
                    {formErrors.phone && <span className="error-message">{formErrors.phone}</span>}
                    
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="company">Empresa</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="vehicleCount">Número de Vehículos</label>
                    <select
                      id="vehicleCount"
                      name="vehicleCount"
                      value={formData.vehicleCount}
                      onChange={handleChange}
                    >
                      <option value="">Seleccionar</option>
                      <option value="1-5">1-5</option>
                      <option value="6-20">6-20</option>
                      <option value="21-50">21-50</option>
                      <option value="51-100">51-100</option>
                      <option value="100+">Más de 100</option>
                    </select>
                  </div>
                </div>
                
                <div className="form-group">
                  <label htmlFor="message">Mensaje *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    className={formErrors.message ? 'error' : ''}
                  ></textarea>
                  {formErrors.message && <span className="error-message">{formErrors.message}</span>}
                  
                </div>
                
                <button type="submit" className="btn btn-primary btn-lg">
                  Enviar Mensaje
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;